import { useTranslation } from "react-i18next";
import { useJobRoleDetailsContext } from "../../components/JobRoleDetailsTree/JobRoleDetails";
import { Row } from "react-bootstrap";

export default function TechAreaHelper({
  searchObject,
  onChange,
  techAreaList,
  techRoleList,
  errors
}) {
  const { t } = useTranslation();
  const { setHelperOpen } = useJobRoleDetailsContext();

  return (
    <Row>
      <div className="col-md-7">
        <label>
          {t("Tech Area")}*
          <a
            className="col text-end"
            href="#"
            onClick={() => setHelperOpen(true)}
            style={{marginLeft:"25px"}}
          >
            {t("View Categorization")}
          </a>
        </label>
        {errors.techAreaId && (
            <div className="error-msg">{errors.techAreaId}</div>
        )}
        <select
          className="form-select"
          name="techAreaId"
          id="techAreaId"
          onChange={onChange}
          value={searchObject.techAreaId || ""}
        >
            <option key={0} value={""} selected>
                {t("Select Profesional Category...")}
            </option>
          {techAreaList?.map((techArea) => (
            <option
              key={techArea.id}
              value={techArea.id}
            >
              {t(techArea.description)}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-5">
        <label>{t("Tech Role")}*</label>
        {errors.techRoleId && (
            <div className="error-msg">{errors.techRoleId}</div>
        )}
        <select
          className="form-select"
          name="techRoleId"
          id="techRoleId"
          onChange={onChange}
          value={searchObject.techRoleId || ""}
        >
            <option key={0} value={""} selected>
                {t("Select Role...")}
            </option>
          {techRoleList?.map((techRole) => (
            <option
              key={techRole.id}
              value={techRole.id}
            >
              {t(techRole.description)}
            </option>
          ))}
        </select>
      </div>
    </Row>
  );
}